import i18n from '@/utils/i18n';
import React from 'react';
import { Icons, Typography, XStack } from '@usepepper/sprout-kit-ui';

const ICON_SIZE = 18;

export const OrderEntryMobileOnHoldBanner: React.FC = () => (
  <XStack
    accessibilityRole="alert"
    alignItems="center"
    backgroundColor="$bgError"
    borderRadius="$12"
    gap="$10"
    marginHorizontal="$16"
    marginTop="$12"
    paddingHorizontal="$12"
    paddingVertical="$10"
  >
    <Icons.AlertCircle color="$iconNegativePrimary" size={ICON_SIZE} />
    <Typography color="$textError" flexShrink={1} size="$sm" variant="label">
      {i18n.t('sales_portal.order_entry.account_on_hold')}
    </Typography>
  </XStack>
);
